if (!customElements.get('bg-product-video-slider')) {
  customElements.define(
    'bg-product-video-slider',
    class BgProductVideoSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-bg-product-video-viewport]');
        this.cards = Array.from(this.querySelectorAll('[data-bg-product-video-card]'));
        this.previousButton = this.querySelector('[data-bg-product-video-prev]');
        this.nextButton = this.querySelector('[data-bg-product-video-next]');
        this.controls = this.querySelector('.bg-product-videos__controls');
        this.status = this.querySelector('[data-bg-product-video-status]');

        if (!this.viewport) return;

        this.handlePrevious = () => this.show(this.closestIndex() - 1);
        this.handleNext = () => this.show(this.closestIndex() + 1);
        this.handleScroll = () => this.requestUpdate();
        this.handleKeydown = (event) => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          if (event.target !== this.viewport) return;
          event.preventDefault();
          this.show(this.closestIndex() + (event.key === 'ArrowRight' ? 1 : -1));
        };

        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);
        this.viewport.addEventListener('scroll', this.handleScroll, { passive: true });
        this.viewport.addEventListener('keydown', this.handleKeydown);

        this.querySelectorAll('video').forEach((video) => {
          video.addEventListener('play', () => {
            this.querySelectorAll('video').forEach((otherVideo) => {
              if (otherVideo !== video) otherVideo.pause();
            });
          });
        });

        this.resizeObserver = new ResizeObserver(() => this.requestUpdate());
        this.resizeObserver.observe(this.viewport);
        this.updateButtons();
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.viewport?.removeEventListener('scroll', this.handleScroll);
        this.viewport?.removeEventListener('keydown', this.handleKeydown);
        this.resizeObserver?.disconnect();
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
      }

      cardPosition(card) {
        return card.offsetLeft - this.cards[0].offsetLeft;
      }

      closestIndex() {
        if (!this.cards.length) return 0;
        const current = this.viewport.scrollLeft;
        return this.cards.reduce((closest, card, index) => {
          const distance = Math.abs(this.cardPosition(card) - current);
          return distance < closest.distance ? { index, distance } : closest;
        }, { index: 0, distance: Number.POSITIVE_INFINITY }).index;
      }

      show(index) {
        const targetIndex = Math.max(0, Math.min(index, this.cards.length - 1));
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const left = Math.min(this.cardPosition(this.cards[targetIndex]), maximum);
        this.viewport.scrollTo({ left, behavior: 'smooth' });
        this.updateButtons(left);
      }

      requestUpdate() {
        if (this.updateFrame) cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.updateButtons());
      }

      updateButtons(position = this.viewport.scrollLeft) {
        if (!this.cards.length) return;
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const hasOverflow = maximum > 2;
        const currentIndex = this.closestIndex();

        if (this.controls) this.controls.hidden = !hasOverflow;
        if (this.previousButton) this.previousButton.disabled = !hasOverflow || position <= 2;
        if (this.nextButton) this.nextButton.disabled = !hasOverflow || position >= maximum - 2;
        if (this.status) this.status.textContent = `動画 ${currentIndex + 1} / ${this.cards.length}`;
      }
    }
  );
}
